export default __webpack_public_path__ + "static/media/ashok2.53e7f056.jpg";